import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import _ from 'lodash';
import { Popup, Icon, Button } from 'semantic-ui-react';
import PrivateDataComponent from '../private-data-component';

const sf = num => numeral(num).format('0a');
const isGraphQLEmpty = obj => obj && (obj.length === 1) && (obj[0] === null);

const InstagramImpressions = ({ latestStatistic, popupToggleHandler, supportingData, instagramAuthorised, post }) => {
  const insights = latestStatistic.insights;

  if (insights && insights.error) {
    const { error } = insights;
    return (
      <Popup
        trigger={
          <Button
            color="orange"
            inverted
            icon="warning"
            fluid
            size="small"
            content="ooops"
            labelPosition="left"
            onClick={_.noop}
          />
        }
      >
        <Popup.Header>{error.error_user_title}</Popup.Header>
        <Popup.Content>{error.error_user_msg}</Popup.Content>
      </Popup>
    );
  }

  if (insights) {
    return (
      <Button
        color="pink"
        inverted
        icon="pie graph"
        labelPosition="left"
        fluid
        content={instagramAuthorised ? sf(insights.impressions) : 'insights'}
        onClick={() => popupToggleHandler(latestStatistic, post)}
        size="small"
      />
    );
  }

  if ((supportingData && supportingData.length) && !isGraphQLEmpty(supportingData)) {
    const filtered = _.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
    const ordered = _.reverse(_.sortBy(filtered, o => o.createdDate));
    const latestSupportingData = ordered[0];
    const impressions = latestSupportingData.impressions;
    return (
      <Button
        color="pink"
        inverted
        icon="pie graph"
        labelPosition="left"
        fluid
        content={instagramAuthorised ? sf(impressions) : <Icon name="lock" color="orange" />}
        disabled
        size="small"
      />
    );
  }

  return (
    <PrivateDataComponent />
  );
};

InstagramImpressions.propTypes = {
  latestStatistic: PropTypes.object.isRequired,
  popupToggleHandler: PropTypes.func.isRequired,
  supportingData: PropTypes.object.isRequired,
  instagramAuthorised: PropTypes.any,
};

InstagramImpressions.defaultProps = {
  instagramAuthorised: false,
};

export default InstagramImpressions;



/** WEBPACK FOOTER **
 ** ./src/components/instagram-impressions/index.js
 **/